var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-margins"},[_c('IssueRowCard',{attrs:{"issue":_vm.issue,"cutoverplan":_vm.cutoverplan}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }